import moment from "moment";
import { Div, Collection, Span } from "@tblabs/truffle";
import { StepState } from "../../../../../../Models/StepState";
import { StepsMarker } from "../../../../../../Services/StepsMarker";
import { Step } from "../../../../../../Steps/Step/Step";
import { TimeUtils } from "../../../../../../Utils/TimeUtils";
import { DateTimeProvider } from "../../../../../../Services/DateTimeProvider";
import { TableEntryV2 } from "./TableEntry";


export class StepsListPrinter extends Div
{
    constructor(private steps: Collection<Step<any>>)
    {
        super();
        this.FontSize(12)

        const markedSteps = StepsMarker.Mark(this.steps.Items);

        for (const x of markedSteps)
        {
            const label = new Span(`${x.Step.GetTitleForCustomer()} ${x.StateAsIcon} ${x.Step.GetStateName()}`).Style("white-space: nowrap;");
            const secondsLeft = moment(x.Step.Timeout).diff(moment(DateTimeProvider.Now), 'seconds');
          
            const warning = secondsLeft > 0
                ? "Wygasa za " + TimeUtils.FormatDuration(secondsLeft)
                : "🟠 Wygasło " + TimeUtils.FormatDuration(-secondsLeft) + " temu";
            const entryInfo = {
                Content: [label],
                ExtraInfo: [],
            };
            if (warning && x.IsCurrent && secondsLeft != 0)
                entryInfo.ExtraInfo.push(warning);

            const entry = new TableEntryV2(entryInfo);

            if (x.IsCurrent)
                entry.Style("background-color: #def7ff;");
            if (x.State == StepState.Failed)
                entry.Style("background-color: #ffe6e8;");
            if (x.IsAfterCurrent)
                entry.Style("opacity: 0.6;");
            
            if (secondsLeft < -60 * 60 * 24 * 3)
                entry.Style("border: 3px solid #f6f10c");
            
            this.Append(entry);
        }
    }
}
